
// src/components/MainPage.js
import React from 'react';
import { useSelector } from 'react-redux';
import styles from './TRViwerPage.module.css';
import TRViwerTechnicalAnalisys from '../components/TRViwerTechnicalAnalisys';
import SymbolDescription from '../components/SymbolDescription';
import TRViewerSymbolDetails from '../components/TRViewerSymbolDetails';

function TRViwerPage(){
    const { selectedSymbol } = useSelector(state => state.streamCryptoInfo);
        
    return (
        <>            
            {selectedSymbol && (
                <div className={styles.main_page}>
                    <header className={styles.main_header}>                        
                    </header>
                    <main>
                        <section className={styles.content}>
                            <div style={{cursor:'not-allowed', pointerEvents: 'none'}}>
                                <TRViewerSymbolDetails symbol={selectedSymbol.replace('-', '')}/>
                            </div>                            
                            <TRViwerTechnicalAnalisys symbol={selectedSymbol.replace('-', '') + 'T'} />                             
                            <SymbolDescription symbol={selectedSymbol.replace('-USD', '')}/>                                                       
                        </section>
                    </main>
                </div>
            )}
        </>
    );
}

export default TRViwerPage;






